import styles from '../Signup.module.css'
import fieldStyles from 'components/Fields/Fields.module.css'

import Button from 'components/Button'
import { SelectField, TextField, TextareaField } from 'components/Fields'
import Checkbox from 'components/Fields/Checkbox'
import Heading from 'components/Heading'

const ChooseAbout = ({ setValue, profile_type, handleSubmit, formField, isSubmitting }) => {
  const { about, title, employmentStatus, businessStatus } = formField

  const submit = () => {
    setValue('step', 'about')
    handleSubmit()
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>
        Tell people a little about yourself.
      </Heading>
      <div className={styles['choose-about-wrapper']}>
        <div className={styles['about-wrapper']}>
          <TextareaField limit={200} cols={10} rows={3} name={about.name} label={about.label} />

          <TextField name={title.name} label={title.label} className={styles['signup-input']} />

          {profile_type !== 'business' && profile_type !== 'student' && (
            <SelectField
              name={employmentStatus.name}
              placeholder={employmentStatus.label}
              options={employmentStatus.options}
            />
          )}

          {profile_type === 'business' && (
            <div>
              <label htmlFor={`business_status`} className={fieldStyles['label']}>
                {`Business Status`}
              </label>

              {businessStatus.options.map((item, index) => {
                return (
                  <div key={`business-option${index}`} className={styles['business-option-field']}>
                    <Checkbox name="business_status" label={item.label} value={item.value}>
                      {item.label}
                    </Checkbox>
                  </div>
                )
              })}
            </div>
          )}

          <Button onClick={submit} primary centered disabled={isSubmitting} spinner={isSubmitting}>
            Next
          </Button>
        </div>

        <div className={styles['form-footer']}>
          <Button onClick={submit} block primary={false} disabled={isSubmitting} spinner={isSubmitting}>
            Skip
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ChooseAbout
